import { Element,Prop,Event,EventEmitter,Component, h } from '@stencil/core';

@Component({
  tag: 'ci-drawer',
  styleUrl: 'ci-drawer.scss',
  shadow: true,
})
export class ciDrawer {
  @Element() $el: HTMLElement;
  @Prop() open: boolean;
  @Event() close: EventEmitter<void>;

  render() {
    return (
      <div class="ci-drawer">
        <div class="ci-drawer-window">
          <div class="ci-drawer-overlayClickable" onClick={() => this.close.emit()}></div>
          <div class={{
            'ci-drawer-overlay': true,
            'openOverlay': this.open,
            'closeOverlay': !this.open
          }} id="overlay"></div>
          <div class={{
            'ci-drawer-menu': true,
            'openMenu': this.open,
            'closeMenu': !this.open
          }} id="menu">
            <slot />
          </div>
        </div>
      </div>
    );
  }
}
